import { motion } from "motion/react"
import { useEffect } from "react"

import { type TransitionScope, useTransitionStore } from "@/store"

import styles from "./index.module.scss"

interface Props {
    scope: TransitionScope
}

const MAP_TRANSITION_DURATION = 0.2
const MAP_TRANSITION_HOLD_MS = 300
const FULL_TRANSITION_DURATION = 0.5
const FULL_TRANSITION_HOLD_MS = 300

export const FadeTransition: React.FC<Props> = ({ scope }) => {
    const {
        isActive,
        scope: activeScope,
        phase,
        onSwitch,
        setPhase,
        finish,
    } = useTransitionStore()
    const transitionDuration =
        scope === "map" ? MAP_TRANSITION_DURATION : FULL_TRANSITION_DURATION
    const holdDurationMs =
        scope === "map" ? MAP_TRANSITION_HOLD_MS : FULL_TRANSITION_HOLD_MS

    useEffect(() => {
        if (activeScope !== scope) return
        if (phase !== "hold" || !onSwitch) return
        onSwitch()
        const timer = setTimeout(() => setPhase("fadeOut"), holdDurationMs)
        return () => clearTimeout(timer)
    }, [phase, onSwitch, setPhase, holdDurationMs, activeScope, scope])

    if (!isActive || activeScope !== scope) return null

    return (
        <motion.div
            className={
                scope === "full" ? styles.fullOverlay : styles.mapOverlay
            }
            initial={{ opacity: 0 }}
            animate={{ opacity: phase === "fadeOut" ? 0 : 1 }}
            transition={{ duration: transitionDuration, ease: "easeInOut" }}
            onAnimationComplete={() => {
                if (phase === "fadeIn") setPhase("hold")
                if (phase === "fadeOut") finish()
            }}
        />
    )
}
